<template>
  <div class="d-flex justify-content-around mt-4">
    <router-link
      v-if="getPrev.text"
      class="btn btn-primary rounded-pill d-flex align-items-center"
      :class="{ disabled: getPrev.meta.disabled ?? false }"
      :to="{ name: getPrev.name, params: { menuid: $route.params.menuid } }"
    >
      <i class="bi bi-arrow-left-circle-fill h4 lh-1" style="margin: 0 0.5rem 0 -0.1rem"></i>
      Zurück zu {{ getPrev.text }}
    </router-link>
    <router-link
      v-if="getNext.text"
      class="btn btn-primary rounded-pill d-flex align-items-center"
      :class="{ disabled: getNext.meta.disabled ?? false }"
      :to="{ name: getNext.name, params: { menuid: $route.params.menuid } }"
    >
      {{ getNext.text == 'Bestellung' ? 'Weiter zur Bestellung' : 'Weiter zu ' + getNext.text }}
      <i class="bi bi-arrow-right-circle-fill h4 lh-1" style="margin: 0 -0.1rem 0 0.5rem"></i>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    links: {
      type: Array,
      default: null,
    },
  },
  setup() {
    return {};
  },
  computed: {
    getPrev() {
      for (let i = 1; i < this.links.length; i++) {
        if (this.links[i].name == this.$route.name) return this.links[i - 1];
      }
      return {};
    },
    getNext() {
      for (let i = 0; i < this.links.length - 1; i++) {
        if (this.links[i].name == this.$route.name) return this.links[i + 1];
      }
      return {};
    },
  },
};
</script>

<style lang="scss" scoped></style>
